export default __webpack_public_path__ + "static/media/baby-7.df4831fd.svg";